import { Environments } from '@/config';
import { HELIX_MHHS_PRODUCTION } from './helix-mhhs.production';
import { HELIX_MHHS_STAGING } from './helix-mhhs.staging';

export const HELIX_MHHS = import.meta.env.MODE === Environments.PROD ? HELIX_MHHS_PRODUCTION : HELIX_MHHS_STAGING;
